import {
  API_ERROR,
  RFQ_LIST_SR,
  RFQ_LIST_SR_SUCCESS,
  SELECT_CHANGEVALUE_SR,
  RFQ_ROW_DATA_SR,
  RFQ_ROW_DATA_SR_SUCCESS,
  QUOTATION_ROW_DATA_SR,
  QUOTATION_ROW_DATA_SR_SUCCESS,
  QUOTATION_CHECKED_SR,
  APPROVED_QUANTITY_SR,
  RESET_CELL_UPDATE,
  SR_COMPARE_QUOTATION_ADD,
  SR_COMPARE_QOUTATION_DATA,
  SR_COMPARE_QOUTATION_DATA_SUCCESS,
  SR_COMPARE_QOUTATION_LIST,
  SR_COMPARE_QOUTATION_LIST_SUCCESS,
  PURCHASE_ORDER_SR_DATA,
  PURCHASE_ORDER_SR_LIST,
  PURCHASE_ORDER_SR_LIST_SUCCESS,
  GENERATE_PURCHASE_ORDER_SR,
  GENERATE_PURCHASE_ORDER_SR_RESPONSE,
  SET_SR_PARAMS,
  FILTER_INPUT_CHANGEVALUE_SR,
  FILTER_SELECT_CHANGEVALUE_SR,
  TOGGLE_SR_ITEM_MENU,
  SR_LIST_LAYOUT,
  FILTERS_SHOW_SR_RIGHT_SIDEBAR,
  FILTERS_HIDE_SR_RIGHT_SIDEBAR,
  CLEAR_FILTER,
  SR_PO_MODEL_CLOSE,
  SR_PO_MODEL_OPEN,
  SR_PO_VEND_DATA,
  INPUT_CHANGEVALUE_SR,
  SR_PO_SELECT_CHANGEVALUE_SR,
  RESET_SUBLOCATION,
} from "./actionTypes";

export const getRFQList = (data) => {
  return {
    type: RFQ_LIST_SR,
    payload: { data },
  };
};
export const getRFQListSuccessful = (response) => {
  return {
    type: RFQ_LIST_SR_SUCCESS,
    payload: response,
  };
};
export const SelecteChangeValue = ({ key, label, key2, value }) => {
  return {
    type: SELECT_CHANGEVALUE_SR,
    payload: { key, label, key2, value },
  };
};
export const getRFQRequestdata = (rfqId) => {
  return {
    type: RFQ_ROW_DATA_SR,
    payload: { rfqId },
  };
};
export const getRFQRequestdataSuccessful = (request) => {
  return {
    type: RFQ_ROW_DATA_SR_SUCCESS,
    payload: request,
  };
};
export const getQuotationsData = (rfqId) => {
  return {
    type: QUOTATION_ROW_DATA_SR,
    payload: { rfqId },
  };
};
export const gettQuotationsDataSuccessful = (request) => {
  return {
    type: QUOTATION_ROW_DATA_SR_SUCCESS,
    payload: request,
  };
};
export const QuotationChecked = (checked, index, vendorId) => {
  return {
    type: QUOTATION_CHECKED_SR,
    payload: { checked, index, vendorId },
  };
};
export const ApprovedQuantity = (ApprovedQuantity, index, vendorId) => {
  return {
    type: APPROVED_QUANTITY_SR,
    payload: { ApprovedQuantity, index, vendorId },
  };
};
export const resetCellUpdate = () => {
  return {
    type: RESET_CELL_UPDATE,
    payload: {},
  };
};
export const CompareQuotationAdd = (data, cqId, history) => {
  return {
    type: SR_COMPARE_QUOTATION_ADD,
    payload: { data, cqId, history },
  };
};
export const getCompareQuotationData = (cqId) => {
  return {
    type: SR_COMPARE_QOUTATION_DATA,
    payload: { cqId },
  };
};
export const CompareQuotationDatasuccessfull = (response) => {
  return {
    type: SR_COMPARE_QOUTATION_DATA_SUCCESS,
    payload: response,
  };
};
export const getCompareQuotationList = (data) => {
  return {
    type: SR_COMPARE_QOUTATION_LIST,
    payload: { data },
  };
};
export const CompareQuotationListSuccessful = (response) => {
  return {
    type: SR_COMPARE_QOUTATION_LIST_SUCCESS,
    payload: response,
  };
};

export const SetParams = (params) => {
  return {
    type: SET_SR_PARAMS,
    payload: params,
  };
};
export const FilterChangeValue = ({ key, value }) => {
  return {
    type: FILTER_INPUT_CHANGEVALUE_SR,
    payload: { key, value },
  };
};
export const FilterSelecteChangeValue = ({ key, label, key2, value }) => {
  return {
    type: FILTER_SELECT_CHANGEVALUE_SR,
    payload: { key, label, key2, value },
  };
};
export const toggleItemMenu = (id) => {
  return {
    type: TOGGLE_SR_ITEM_MENU,
    payload: id,
  };
};

export const PurchaseOrderData = (data) => {
  return {
    type: PURCHASE_ORDER_SR_DATA,
    payload: data,
  };
};
export const GetPurchaseOrderList = (rfqId) => {
  return {
    type: PURCHASE_ORDER_SR_LIST,
    payload: { rfqId },
  };
};
export const GetPurchaseOrderListSucces = (response) => {
  return {
    type: PURCHASE_ORDER_SR_LIST_SUCCESS,
    payload: response,
  };
};
export const GeneratePurchaseOrder = (data) => {
  return {
    type: GENERATE_PURCHASE_ORDER_SR,
    payload: { data },
  };
};
export const GeneratePurchaseOrderResponse = (data, requestStatus, loading) => {
  return {
    type: GENERATE_PURCHASE_ORDER_SR_RESPONSE,
    payload: { data, requestStatus, loading },
  };
};
export const listlayout = (layout) => {
  return {
    type: SR_LIST_LAYOUT,
    payload: layout,
  };
};
export const FiltersShowRightSidebar = () => {
  return {
    type: FILTERS_SHOW_SR_RIGHT_SIDEBAR,
    payload: null,
  };
};
export const FiltershideRightSidebar = () => ({
  type: FILTERS_HIDE_SR_RIGHT_SIDEBAR,
  payload: null,
});
export const FilterClear = () => {
  return {
    type: CLEAR_FILTER,
    payload: null,
  };
};
export const po_model_open = (CQID) => {
  return {
    type: SR_PO_MODEL_OPEN,
    payload: CQID,
  };
};
export const po_model_close = () => {
  return {
    type: SR_PO_MODEL_CLOSE,
  };
};
export const PurchaseOrderVendData = (index) => {
  return {
    type: SR_PO_VEND_DATA,
    payload: { index },
  };
};
export const InputChangeValue = ({ key, value }) => {
  return {
    type: INPUT_CHANGEVALUE_SR,
    payload: { key, value },
  };
};

export const ResetSubLocation = () => {
  return {
    type: RESET_SUBLOCATION,
  };
};
export const POSelecteChangeValue = ({ key, label, key2, value }) => {
  return {
    type: SR_PO_SELECT_CHANGEVALUE_SR,
    payload: { key, label, key2, value },
  };
};
export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};
